import { render, staticRenderFns } from "./DrawBoardNew.vue?vue&type=template&id=09578ea2&scoped=true"
import script from "./DrawBoardNew.vue?vue&type=script&lang=js"
export * from "./DrawBoardNew.vue?vue&type=script&lang=js"
import style0 from "./DrawBoardNew.vue?vue&type=style&index=0&id=09578ea2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09578ea2",
  null
  
)

export default component.exports